'use strict';
(function(angular) {
  angular.module('fetchtv.services')
    .factory('binDbService', [
      '$http',
      '$q',
      '$filter',
      'proxyprefix',
      function(
        $http,
        $q,
        $filter,
        proxyprefix,
      ) {
        return {
          checkBin: function(options) {
            var deferred = $q.defer();

            $http.get(proxyprefix + '/bincheck?bin=' + options.bin)
              .success(function(data) {
                if (data.__meta__.error) {
                  deferred.reject(data.__meta__.error);
                } else {
                  if (options.allowedCountries.indexOf(data.country) > -1) {
                    deferred.resolve();
                  } else {
                    deferred.reject(data.country);
                  }
                }
              })
              .error(function(error) {
                deferred.reject(error);
              });

            return deferred.promise;
          }
        };
      }]);
})(angular);

